import React, { useState, useEffect } from 'react';
import './Newlocationotp.css'
import { useNavigate } from 'react-router-dom';

export default function OtpNewlocation() {
  const [submitted, setSubmitted] = useState(false);
  const [fromLocalStorage, setFromLocalStorage] = useState('');
  const [otp, setOtp] = useState('');
  const [isverified, setisverified] = useState(false);
  const [expired, setexpired] = useState(false);
  const [wrongotp, setwrongotp] = useState(false);


  const nav = useNavigate()


  useEffect(() => {
    const storedEmail = localStorage.getItem('submittedEmail');
    if (storedEmail) {
      setFromLocalStorage(storedEmail);
      setSubmitted(true);

      sendotp(storedEmail);
    }
  }, []);


  async function updatecoordinates(lat,long){



    const res = await fetch('https://otp-alertlocation.vercel.app/updatecoordinatesofalert', {
    method: 'POST',
    body: JSON.stringify({ lat, long,fromLocalStorage }),
    headers: { 'Content-Type': 'application/json' },
  });
  const post = await res.json();


  nav('/alertme')




  }

function getCurrentLocationCoordinates() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      updatecoordinates(latitude, longitude);
    });
  } else {
    console.error('Geolocation is not supported in this browser.');
  }
}




  async function handleOtpSubmit() {


    const res = await fetch('https://otp-alertlocation.vercel.app/otpmatchwithnewlocationmodel', {
      method: 'POST',
      body: JSON.stringify({ fromLocalStorage, otp }),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();

    if (post === 'verified') {
      setisverified(true);
    } else if (post === 'otexpiredp') {
      setexpired(true);
      setwrongotp(true);

    }

    else if (post === 'invalidotp') {

      setwrongotp(true);
    }
  }

  async function sendotp(storedemail) {
    console.log(fromLocalStorage);
    const res = await fetch('https://otp-alertlocation.vercel.app/newlocationotp', {
      method: 'POST',
      body: JSON.stringify({ storedemail }),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();
    


  }



  async function resendotp() {
    setOtp('')
    console.log(fromLocalStorage);
    const res = await fetch('https://otp-alertlocation.vercel.app/newlocationresend', {
      method: 'POST',
      body: JSON.stringify({ fromLocalStorage }),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();

    if (post === 'otpalreadysent') {
      // Handle already sent OTP
    } else {
      // Handle OTP send success
    }
  }



  return (
    <div className="otp-container">
      {isverified ? (
     <div className="success-box">
     <p className="success-message">Verified</p>
     <button className='otpbutton' onClick={getCurrentLocationCoordinates}>
       Update Location to Current Location
     </button>
  
   </div>
   
      ) : (
        <div className="otp-box">
          {submitted ? (
            <>
              <p className="otp-sent-message">OTP sent to  <u>{fromLocalStorage}</u>  . Please check your mail inbox.</p>
              <br />
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={{
                  border: '1px solid #000', // Set the border style
                  borderRadius: '5px',      // Add border radius for rounded corners
                  padding: '10px',          // Add padding for better appearance
                  // Add any other styles you want here
                }}
              />

              <br />
              <br />
              <button className='otpbutton' onClick={handleOtpSubmit}>Verify OTP</button>
              <br />
              <br />
              <br />

              {expired && wrongotp ? <>


                <div className="error-box">
                  <h6 className="error-message">Invalid OTP</h6>
                  <button
                    className='otpbutton'
                    onClick={() => {
                      resendotp()
                      setwrongotp(false);
                      setexpired(false);
                    }}
                  >
                    Resend OTP ?
                  </button>



                </div>


              </> : <>


                {wrongotp ? (
                  <div className="error-box">
                    <h6 className="error-message">Invalid OTP</h6>
                    <button
                      className='otpbutton'
                      onClick={() => {
                        resendotp()
                        setwrongotp(false);
                        setexpired(false);
                      }}
                    >
                      Resend OTP ?
                    </button>



                    {expired ? (
                      <>
                        <h6 className="error-message">OTP is expired</h6>
                        <button
                          className='otpbutton' onClick={() => {
                            resendotp()
                            setwrongotp(false);
                            setexpired(false);
                          }}
                        >
                          Resend OTP
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}






              </>}




            </>
          ) : (
            <div className="no-email-box">
              <p className="no-email-message">No email found in local storage.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
